export default __webpack_public_path__ + "74bfadadab5ae315dcaa37e0e112fef5.svg";